import { Outlet } from 'react-router-dom';

/** Full-viewport layout for login / register (no app chrome). */
export default function AuthLayout() {
  return (
    <div className="min-h-screen">
      <Outlet />
    </div>
  );
}
